import { fetchEffectiveDues } from '../service/api/dues.api';
import { fetchExemptionRenewReasons, fetchReasonById, fetchReasons } from '../service/api/exemptions.api';
import { formatDateForInput } from '../utils/filters';

export default {
    methods: {
        async fetchStructures() {
            const { data } = await fetchEffectiveDues();
            this.effectiveDues = data.items;
        },
        async fetchChosenReason(id) {
            const { data } = await fetchReasonById(id, this.enterpriseUuid ?? null);
            this.chosenReason = data;
        },
        async handleEffectiveDueChange() {
            if (null !== this.formData.beneficiaryId) {
                await this.handleBeneficiaryChange(this.formData.beneficiaryId);
            }
        },
        async handleBeneficiaryChange(selectBeneficiaryId, enterpriseUuid, isRenew = false) {
            let due = await this.getDueById(this.formData.dueId);

            if (!due) {
                return;
            }

            const { code: selectBeneficiaryCode } = this.beneficiaries.find((beneficiary) => {
                return beneficiary.id === parseInt(selectBeneficiaryId);
            });

            await this.guessReasons(due, selectBeneficiaryCode, enterpriseUuid, isRenew);
        },
        async guessReasons(due, selectBeneficiaryCode, enterpriseUuid, isRenew = false) {
            const dueBeneficiaryCode = due.beneficiary.code;
            this.formData.oppositeDueId = null;
            const filteredReasons = isRenew
                ? this.filteredExemptionRenewReasons
                : this.filteredBaseReasons
            ;

            switch (true) {
                case dueBeneficiaryCode === 'b1':
                case dueBeneficiaryCode === 'b2' && selectBeneficiaryCode === 'b2':
                case dueBeneficiaryCode === 'b3' && selectBeneficiaryCode === 'b3': {
                    const params = {
                        params: {
                            dueId: due.id,
                            enterpriseUuid,
                        }
                    }

                    const { data } = isRenew && this.exemptionId
                        ? await fetchExemptionRenewReasons(this.exemptionId, params)
                        : await fetchReasons(params);

                    this.reasons = [...filteredReasons, ...data];
                    await this.fillExemptionWithDependentDueDates(due);
                    break;
                }
                case dueBeneficiaryCode === 'b2' && selectBeneficiaryCode === 'b3':
                case dueBeneficiaryCode === 'b3' && selectBeneficiaryCode === 'b2': {
                    const oppositeDue = await this.findSecondDue(due);
                    const params = {
                        params: {
                            dueId: oppositeDue.id,
                            enterpriseUuid,
                        }
                    }
                    const { data } = isRenew && this.exemptionId
                        ? await fetchExemptionRenewReasons(this.exemptionId, params)
                        : await fetchReasons(params)
                    ;

                    this.formData.oppositeDueId = oppositeDue.id;
                    this.reasons = [...this.filteredBaseReasons, ...data];
                    await this.fillExemptionWithDependentDueDates(oppositeDue);
                    break
                }
            }
        },
        async fillExemptionWithDependentDueDates(due) {
            if (due.contractStartDate) {
                this.formData.guarantyEffectiveDate = formatDateForInput(due.contractStartDate);
            }
            if (due.effectStartDate) {
                this.formData.dueDate = formatDateForInput(due.effectStartDate);
            }
        },
        /**
         * Set up reasons if there are no effective dues associated with this enterprise
         * Skip cd7 if enterprise has optional motifs
         * @returns {Promise<void>}
         */
        async handleOptionalMotifs(isRenew = false) {
            if (this.effectiveDues.length === 0) {
                const { data } = await fetchReasons({ params: {
                    enterpriseUuid: this.enterpriseUuid,
                    enterpriseOptionalReasons: true,
                }});
                const filteredReasons = isRenew
                    ? this.filteredExemptionRenewReasons
                    : this.filteredBaseReasons
                ;
                const baseReasons = isRenew
                    ? this.exemptionRenewReasons
                    : this.baseReasons
                ;

                if (data.length > 0) {
                    this.reasons = [...filteredReasons, ...data];
                } else {
                    this.reasons = baseReasons;
                }
            }
        },
        /**
         * Find second due in case selected b2 or b2 beneficiary and due divided into two parts
         * @param selectedDue
         * @returns {Promise<*>}
         */
        async findSecondDue(selectedDue) {
            if (selectedDue.siren != null && selectedDue.siren !== '') {
                return this.getDueBySirenOrSiret('siren', selectedDue);
            }

            return this.getDueBySirenOrSiret('siret', selectedDue);
        },
        getDueById(id) {
            return this.effectiveDues.find((due) => {
                return due.id === id;
            })
        },
        getDueBySirenOrSiret(propertyName, selectedDue) {
            return this.effectiveDues.find((due) => {
                return due[propertyName] === selectedDue[propertyName]
                    && due.beneficiary.code !== selectedDue.beneficiary.code;
            });
        },
        async fetchReasons(isRenew = false) {
            if (this.effectiveDues.length === 0) {
                await this.handleOptionalMotifs(isRenew);

                return;
            }

            if (this.formData.beneficiaryId) {
                await this.handleBeneficiaryChange(this.formData.beneficiaryId, this.enterpriseUuid, isRenew);
            }
        }
    }
}
